import { render, staticRenderFns } from "./SosSolucoes.vue?vue&type=template&id=245b7e02&scoped=true&"
import script from "./SosSolucoes.vue?vue&type=script&lang=js&"
export * from "./SosSolucoes.vue?vue&type=script&lang=js&"
import style0 from "./SosSolucoes.vue?vue&type=style&index=0&id=245b7e02&lang=scss&scoped=true&"
import style1 from "./SosSolucoes.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245b7e02",
  null
  
)

export default component.exports